module.exports = __webpack_public_path__ + "static/media/site_lage_Icon.a22f751d.svg";